export default __webpack_public_path__ + "static/media/chartgpt-icon.6dad38fa.gif";